<template>
  <div class="ma3 list-grid">
    <journal-item v-for="(item, index) in logs" :key="index" :itemContext="itemContext(item)" class="list-item" />
  </div>
</template>

<script>
import JournalItem from './JournalItem.vue'

export default {
  props: ['id', 'state', 'journalContext'],
  components: {
    JournalItem
  },
  watch: {
    id: {
      immediate: true,
      handler: async function (id) {
        this.journalContext.loadLogsJournal().then((logs) => {
          this.logs = logs
        })
      }
    },
    state: {
      immediate: true,
      handler: async function (state) {
        if (state.status_code.spec.causer) {
          this.journalContext.loadLogsJournal().then((logs) => {
            this.logs = logs
          })
        }
      }
    }
  },
  data () {
    return {
      logs: []
    }
  },
  methods: {
    itemContext (item) {
      return {
        item: item,
        statusByCode: this.journalContext.statusByCode,
        cardLink: this.journalContext.cardLinkName,
        parentId: this.id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  padding: .5rem .5rem .5rem .5rem;
  background-color: #FFFFFF;
}
</style>
